import script from "./graphCol.vue?vue&type=script&setup=true&lang=js"
export * from "./graphCol.vue?vue&type=script&setup=true&lang=js"

import "./graphCol.vue?vue&type=style&index=0&id=357c5760&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357c5760"]])

export default __exports__